module.exports = __webpack_public_path__ + "img/section-header.99a8189.svg";